import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'

import { privacy_policy_link, terms_of_service_link } from 'utils'

import { ReactComponent as EthereumIcon } from 'sources/images/ethereumIcon.svg'
import { ReactComponent as PolygonIcon } from 'sources/images/polygonIcon.svg'
import { ReactComponent as IpfsIcon } from 'sources/images/ipfsIcon.svg'

import styles from './styles.module.scss'


interface IProps {
}

export const FooterPWA: FC<IProps> = props => {
  return (
    <footer className={styles.footer}>
      <div className={styles.boxContent}>
        <div className={styles.poweredByBox}>
          <div className={styles.poweredByTitle}>Powered by:</div>
          <div className={cn(styles.ethereumIcon, styles.icon)}>
            Ethereum <EthereumIcon/>
          </div>
        </div>
        <div className={cn(styles.polygonIcon, styles.icon)}>
          Polygon <PolygonIcon/>
        </div>
        <div className={cn(styles.ipfsIcon, styles.icon)}>
          IPFS <IpfsIcon/>
        </div>

        <NavLink className={styles.link} to={terms_of_service_link()}>
          Terms of service
        </NavLink>
        <NavLink className={styles.link} to={privacy_policy_link()}>
          Privacy policy
        </NavLink>
      </div>
    </footer>
  )
}
